import Chart from 'react-apexcharts';

const PaymentTypePolarChart = ({ paymentWiseData }) => {
    // Ensure the chart renders even if data is empty
    const hasData = paymentWiseData.length > 0;
    const labels = hasData ? paymentWiseData.map(item => item.paymentType || 'Unknown') : ['No Data'];
    const series = hasData ? paymentWiseData.map(item => item.count) : [0];
    const options = {
        chart: {
            type: 'polarArea'
        },
        labels,
        legend: {
            position: 'bottom'
        },
        stroke: {
            colors: ['#fff'] // White lines between segments
        },
        fill: {
            opacity: 0.8
        },
        yaxis: {
            labels: {
                style: {
                    colors: '#000', // Make the numbers black
                    fontSize: '17px',
                    fontWeight: '900'
                }
            }
        }
    };

    return (
        <div>
            <Chart
                options={options}
                series={series}
                type="polarArea"
                width={300}
            />
        </div>
    );
};

export default PaymentTypePolarChart;

